import { mapEventType } from '../../helper/map-event-type';
export var eventKey = function eventKey(config, _data, globalConfig) {
  return {
    'event:key': "".concat(globalConfig.product, ".fe.").concat(mapEventType(config.type), ".").concat(config.key)
  };
};